<template>
	<div>
		<AppLoading v-if="carregando" />
		<template v-else-if="erro"> {{ erro }} </template>
		<template v-else-if="irmao">
			<ComponentAuthGuard
				:requires="[adminIrmaoGuard]"
			>
				<v-btn
					fixed
					dark
					fab
					bottom
					right
					:style="{bottom: `${$vuetify.application.bottom + 10}px`}"
					color="primary"
					@click="() => irmao && $router.push({
						name: 'editar-irmao',
						params: { id: irmao._id },
					})"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</ComponentAuthGuard>
			<CabecalhoDeDetalhesDoIrmao :irmao="irmao" />
			<v-card>
				<v-tabs
					key="tabs"
					fixed-tabs
					v-model="tab"
					background-color="primary"
					dark
				>
					<v-tab
						v-for="tab in tabs"
						:key="tab"
						:tab-value="tab"
					>
						{{ tab }}
					</v-tab>
					<v-tab-item value="Geral">
						<AbaGeralDoIrmao :irmao="irmao" />
						<v-divider />
						<AbaPessoalDoIrmao :irmao="irmao" />
					</v-tab-item>
					<v-tab-item value="Serviços">
						<AbaDeServicosDoIrmao :irmao="irmao" />
					</v-tab-item>
					<v-tab-item value="Certificados">
						<AbaDeCertificadosDoIrmao :irmao="irmao" />
					</v-tab-item>
				</v-tabs>
			</v-card>
		</template>
		<div style="height:56px;" />
	</div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import Irmao from '@/../common/types/Irmao'
import IrmaoService from '@/services/IrmaoService'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import { adminIrmaoGuard as guardaDeAdminDoIrmao } from '@/shareds/sharedsIrmao'
import { getErrorMessage } from '@/helpers/error-helpers'
import CabecalhoDeDetalhesDoIrmao from './components/CabecalhoDeDetalhesDoIrmao.vue'
import AbaGeralDoIrmao from './components/AbaGeralDoIrmao.vue'
import AbaPessoalDoIrmao from './components/AbaPessoalDoIrmao.vue'
import AbaDeServicosDoIrmao from './components/AbaDeServicosDoIrmao.vue'
import AbaDeCertificadosDoIrmao from './components/AbaDeCertificadosDoIrmao.vue'
import { useRoute, useRouter } from '@/composables/router'

const props = defineProps({
	id: { type: String, required: true },
})

const router = useRouter()
const route = useRoute()

const carregando = ref(true)
const erro = ref<string | undefined>(undefined)
const irmao = ref<Irmao | null>(null)
const tabs = ['Geral', 'Serviços', 'Certificados']

async function buscarIrmao() {
	carregando.value = true
	erro.value = undefined
	try {
		irmao.value = await IrmaoService.get(props.id)
	} catch (error) {
		erro.value = getErrorMessage(error)
	} finally {
		carregando.value = false
	}
}

buscarIrmao()

const adminIrmaoGuard = computed(() => {
	if (!irmao.value) return () => false
	return guardaDeAdminDoIrmao(irmao.value)
})

const tab = computed({
	get: () => typeof route.query.t === 'string' ? route.query.t : 'Geral',
	set: (novaTab: string) => {
		router.replace({
			name: 'detalhar-irmao',
			params: { id: props.id },
			query: { t: novaTab },
		})
	},
})
</script>
